import { IFormatterProps } from '../../@types/workspaceTypes';
import { useSelector } from 'react-redux';
import React, { useContext } from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { IFullUserDetails, Maybe } from '../../graphql/schema/p4types';
import { useStatusCellStyles } from './util';
import { ComponentContext, IFlattenedProductComponent } from '../CommonOrderComponents/SalesOrderComponentGrid';

export const ComponentStatusCellFormatter = (props: IFormatterProps<IFlattenedProductComponent>) => {
  const fullUserDetails = useSelector((store: any) => store.app.fullUserDetails as Maybe<IFullUserDetails>);

  //To determine how much stock is required, we need details about the SalesOrderLine, which we can get from these contexts.
  const { lineOutstandingLessFreeStock } = useContext(ComponentContext);

  const { dependentValues, rowIdx, idx, column } = props;

  const styles = useStatusCellStyles();

  const componentQuantity = dependentValues.rowData?.quantity ?? 0;
  const componentOutstanding = lineOutstandingLessFreeStock * componentQuantity;

  const freeStock = dependentValues.rowData.productWarehouseDetail?.freeStock ?? 0;

  let cellClassName: string | undefined;
  if (freeStock < componentOutstanding) {
    cellClassName = styles.cellDanger;
  } else {
    cellClassName = styles.cellSuccess;
  }

  //If status display is disabled, or no product is selected yet, show the regular RowMoveCell component with standard styling.
  if (!fullUserDetails?.companyUser?.additionalStatusDisplays || !dependentValues.rowData.component) {
    return (
      <div
        className={'react-grid-Cell'}
        style={{ width: column.width, height: '100%', position: 'absolute' }}
        data-testid={`datagrid-cell-${rowIdx}-${column.key}`}
        data-value={props.value}
      >
        <div className="react-grid-Cell__value" style={{ position: 'relative' }}>
          {props.value}
        </div>
      </div>
    );
  }

  return (
    <div
      className={mergeClasses(styles.cell, cellClassName)}
      style={{ width: column.width }}
      data-testid={`datagrid-cell-${rowIdx}-${column.key}`}
      data-value={props.value}
    >
      <div className="react-grid-Cell__value" style={{ position: 'relative' }}>
        {props.value}
      </div>
    </div>
  );
};
